//オリジナルjquery
// 最初は.header-wrapper--border-bottom非表示→スクロールで表示
jQuery(function($){
  $(document).ready(function(){
    $('.header-wrapper--border-bottom').hide(); 

    $(window).on('scroll', function(){
      if ($(window).scrollTop() > 100) {
        $('.header-wrapper--border-bottom').fadeIn(400);
      } else {
        $('.header-wrapper--border-bottom').fadeOut(400);
      }
    });
  });
});